/* Original Renegade v44 — native Shopify customer capture with consent-aware session attribution. */
(function(){
'use strict';

var captureSelector='form.or-customer-capture';
var proxySelector='[data-or-capture-proxy]';
var attributionSelector='form.or-customer-capture';
var attributionKey='orAttributionFirstTouch';
var mountQueued=false;

function customerPrivacy(){return window.Shopify&&window.Shopify.customerPrivacy?window.Shopify.customerPrivacy:null}
function analyticsAllowed(){try{var privacy=customerPrivacy();return !!(privacy&&typeof privacy.analyticsProcessingAllowed==='function'&&privacy.analyticsProcessingAllowed());}catch(error){return false}}
function preferencesAllowed(){try{var privacy=customerPrivacy();return !!(privacy&&typeof privacy.preferencesProcessingAllowed==='function'&&privacy.preferencesProcessingAllowed());}catch(error){return false}}
function marketingAllowed(){try{var privacy=customerPrivacy();return !!(privacy&&typeof privacy.marketingAllowed==='function'&&privacy.marketingAllowed());}catch(error){return false}}
function attributionStorageAllowed(){return analyticsAllowed()&&preferencesAllowed()&&marketingAllowed()}
function clearAttribution(){try{window.sessionStorage.removeItem(attributionKey)}catch(error){}}
function readAttribution(){if(!attributionStorageAllowed())return null;try{var raw=window.sessionStorage.getItem(attributionKey);return raw?JSON.parse(raw):null}catch(error){return null}}
function writeAttribution(value){if(!attributionStorageAllowed()||!value)return;try{window.sessionStorage.setItem(attributionKey,JSON.stringify(value))}catch(error){}}

function safeValue(value,maxLength){
  if(typeof value!=='string')return '';
  value=value.trim();
  if(!value||value.indexOf('@')!==-1)return '';
  return value.replace(/[^a-zA-Z0-9_-]+/g,'_').replace(/^_+|_+$/g,'').slice(0,maxLength||40).toUpperCase();
}

function sourceFromReferrer(){
  if(!document.referrer)return null;
  try{
    var ref=new URL(document.referrer);
    if(ref.origin===window.location.origin)return null;
    var host=ref.hostname.toLowerCase();
    if(host.indexOf('google.')!==-1)return {source:'GOOGLE',medium:'ORGANIC'};
    if(host.indexOf('bing.com')!==-1)return {source:'BING',medium:'ORGANIC'};
    if(host.indexOf('duckduckgo.com')!==-1)return {source:'DUCKDUCKGO',medium:'ORGANIC'};
    if(host.indexOf('yahoo.')!==-1)return {source:'YAHOO',medium:'ORGANIC'};
    if(host.indexOf('instagram.com')!==-1)return {source:'INSTAGRAM',medium:'SOCIAL'};
    if(host.indexOf('facebook.com')!==-1||host.indexOf('fb.com')!==-1)return {source:'FACEBOOK',medium:'SOCIAL'};
    if(host==='t.co'||host.indexOf('twitter.com')!==-1||host.indexOf('x.com')!==-1)return {source:'X',medium:'SOCIAL'};
    if(host.indexOf('tiktok.com')!==-1)return {source:'TIKTOK',medium:'SOCIAL'};
    if(host.indexOf('reddit.com')!==-1)return {source:'REDDIT',medium:'SOCIAL'};
    if(host.indexOf('pinterest.')!==-1)return {source:'PINTEREST',medium:'SOCIAL'};
    if(host.indexOf('youtube.com')!==-1||host.indexOf('youtu.be')!==-1)return {source:'YOUTUBE',medium:'SOCIAL'};
    if(host.indexOf('chatgpt.com')!==-1||host.indexOf('openai.com')!==-1)return {source:'CHATGPT',medium:'REFERRAL'};
    if(host.indexOf('perplexity.ai')!==-1)return {source:'PERPLEXITY',medium:'REFERRAL'};
    return {source:'REFERRAL',medium:'REFERRAL'};
  }catch(error){return null}
}

function detectAttribution(){
  if(!attributionStorageAllowed())return null;
  var params;
  try{params=new URLSearchParams(window.location.search)}catch(error){params=null}
  var source=params?safeValue(params.get('utm_source')||'',30):'';
  var medium=params?safeValue(params.get('utm_medium')||'',24):'';
  var campaign=params?safeValue(params.get('utm_campaign')||'',40):'';

  if(params&&!source){
    if(params.get('gclid')||params.get('gbraid')||params.get('wbraid')){source='GOOGLE';medium=medium||'PAID'}
    else if(params.get('fbclid')){source='META';medium=medium||'PAID_SOCIAL'}
    else if(params.get('ttclid')){source='TIKTOK';medium=medium||'PAID_SOCIAL'}
  }

  if(!source){
    var referrer=sourceFromReferrer();
    if(referrer){source=referrer.source;medium=medium||referrer.medium}
  }

  if(!source&&!medium&&!campaign)return null;
  return {source:source,medium:medium,campaign:campaign};
}

function ensureFirstTouch(){
  if(!attributionStorageAllowed()){clearAttribution();return null}
  var existing=readAttribution();
  if(existing)return existing;
  var detected=detectAttribution();
  if(detected)writeAttribution(detected);
  return detected;
}

function attributionTags(){
  var attribution=readAttribution()||ensureFirstTouch();
  if(!attribution)return [];
  var tags=['OR_ATTRIBUTED'];
  if(attribution.source)tags.push('OR_SOURCE_'+safeValue(attribution.source,30));
  if(attribution.medium)tags.push('OR_MEDIUM_'+safeValue(attribution.medium,24));
  if(attribution.campaign)tags.push('OR_CAMPAIGN_'+safeValue(attribution.campaign,40));
  return tags;
}

function mergeAttributionTags(value){
  var current=value?String(value).split(','):[];
  if(!attributionStorageAllowed())return current.filter(Boolean).join(',');
  attributionTags().forEach(function(tag){if(tag&&current.indexOf(tag)===-1)current.push(tag)});
  return current.filter(Boolean).join(',');
}
function appendAttributionTags(form){
  if(!form)return;
  var field=form.querySelector('input[name="contact[tags]"]');
  if(!field)return;
  field.value=mergeAttributionTags(field.value);
}

function sourceFor(form){var field=form.querySelector('[data-or-capture-source]');return field?field.value:'unknown'}
function successTextFor(form){var status=form.querySelector('[data-or-capture-status]');return status&&status.dataset.orCaptureSuccess?status.dataset.orCaptureSuccess:''}
function errorTextFor(form){var status=form.querySelector('[data-or-capture-status]');return status&&status.dataset.orCaptureError?status.dataset.orCaptureError:''}

function setSubmitting(form,submitting){
  form.dataset.orCaptureSubmitting=submitting?'true':'false';
  var button=form.querySelector('[data-or-capture-submit],[data-or-capture-proxy-submit]');
  if(!button)return;
  if(!button.dataset.orDefaultText)button.dataset.orDefaultText=button.textContent;
  button.disabled=submitting;
  button.textContent=submitting?(button.dataset.orSubmittingText||'SAVING…'):button.dataset.orDefaultText;
}

function showStatus(form,type,message){
  var fields=form.querySelector('[data-or-capture-fields]');
  var status=form.querySelector('[data-or-capture-status]');
  if(status){status.hidden=false;status.dataset.orCaptureStatus=type;status.textContent=message}
  if(fields&&type==='success')fields.hidden=true;
}

function handleSuccess(form){
  var source=sourceFor(form);
  showStatus(form,'success',successTextFor(form));
  document.documentElement.dataset.orEmailCaptured='true';
  if(preferencesAllowed())try{window.localStorage.setItem('orMailingPopupHiddenUntil',String(Date.now()+365*86400000))}catch(error){}
  track('signup_pending',source);
  document.dispatchEvent(new CustomEvent('or:customer-captured',{detail:{source:source}}));
}

function nativeFallback(form){form.dataset.orCaptureNative='true';HTMLFormElement.prototype.submit.call(form)}
function canonicalNewsletterForm(){
  return document.querySelector('form.orc-form[data-webmcp-canonical="newsletter"],form.or-customer-capture[data-webmcp-canonical="newsletter"],form.or-customer-capture[toolname="join_renegade_roundup"]');
}
function proxyNativeFallback(proxy,canonical,email,tags){
  if(!canonical){window.location.href=(window.ORTheme&&window.ORTheme.marketRoot)||'/';return}
  var emailField=canonical.querySelector('input[name="contact[email]"]');
  var tagsField=canonical.querySelector('input[name="contact[tags]"]');
  var sourceField=canonical.querySelector('[data-or-capture-source]');
  if(emailField)emailField.value=email;
  if(tagsField)tagsField.value=tags;
  if(sourceField)sourceField.value=sourceFor(proxy);
  nativeFallback(canonical);
}
function submitProxy(proxy){
  if(!proxy||proxy.dataset.orCaptureSubmitting==='true')return;
  var emailField=proxy.querySelector('[data-or-capture-proxy-email]');
  if(!emailField)return;
  if(typeof emailField.checkValidity==='function'&&!emailField.checkValidity()){
    if(typeof emailField.reportValidity==='function')emailField.reportValidity();
    return;
  }
  var canonical=canonicalNewsletterForm();
  if(!canonical){showStatus(proxy,'error',errorTextFor(proxy));return}
  var email=String(emailField.value||'').trim();
  var tags=mergeAttributionTags(proxy.dataset.orCaptureTags||'');
  var data=new FormData(canonical);
  data.set('contact[email]',email);
  data.set('contact[tags]',tags);

  track('signup_submit',sourceFor(proxy));
  setSubmitting(proxy,true);
  showStatus(proxy,'working','');

  fetch(canonical.action,{method:'POST',body:data,credentials:'same-origin',headers:{'Accept':'text/html','X-Requested-With':'XMLHttpRequest'}})
    .then(function(response){
      if(response.url&&response.url.indexOf('/challenge')!==-1){proxyNativeFallback(proxy,canonical,email,tags);return null}
      if(!response.ok)throw new Error('Customer capture request failed');
      return response.text().then(function(html){
        var result=new DOMParser().parseFromString(html,'text/html');
        if(result.querySelector('[data-or-server-success]'))return true;
        var error=result.querySelector('form.or-customer-capture [role="status"] .errors');
        if(error)throw new Error(error.textContent.trim());
        proxyNativeFallback(proxy,canonical,email,tags);return null;
      });
    })
    .then(function(result){if(result===null)return;handleSuccess(proxy);setSubmitting(proxy,false)})
    .catch(function(){setSubmitting(proxy,false);track('signup_error',sourceFor(proxy));showStatus(proxy,'error',errorTextFor(proxy))});
}

function buildCartCapture(surface){
  var template=document.getElementById('ORCartCaptureTemplate');
  if(!template||!template.content)return null;
  var fragment=template.content.cloneNode(true);
  var panel=fragment.querySelector('[data-or-capture-panel]');
  if(!panel)return null;
  panel.classList.add('or-cart-capture--'+surface);
  var form=panel.querySelector(captureSelector);
  var email=panel.querySelector('input[type="email"]');
  var label=panel.querySelector('label[for]');
  var source=panel.querySelector('[data-or-capture-source]');
  if(form)form.id='ORCartCaptureForm-'+surface;
  if(email)email.id='ORCartCaptureEmail-'+surface;
  if(label)label.htmlFor='ORCartCaptureEmail-'+surface;
  if(source)source.value='cart-'+surface;
  return panel;
}

function mountDrawer(){
  var inner=document.querySelector('[data-or-cart-drawer-inner]');
  if(!inner||inner.querySelector('.or-cart-capture--drawer'))return;
  var items=inner.querySelector('.or-cart-drawer__items');
  if(!items)return;
  var panel=buildCartCapture('drawer');
  if(panel)inner.appendChild(panel);
}

function mountCartPage(){
  var page=document.querySelector('.cart-page');
  if(!page||page.querySelector('.or-cart-capture--page'))return;
  var cartForm=page.querySelector('form[id^="ORCartForm-"]');
  if(!cartForm)return;
  var panel=buildCartCapture('page');
  if(panel)page.appendChild(panel);
}

function mountAll(){
  mountQueued=false;
  if(document.documentElement.dataset.orEmailCaptured==='true')return;
  mountDrawer();
  mountCartPage();
}

function queueMount(){if(mountQueued)return;mountQueued=true;window.requestAnimationFrame(mountAll)}

function observeCartRegions(){
  var drawer=document.querySelector('[data-or-cart-drawer]');
  var page=document.querySelector('.cart-page');
  if(typeof MutationObserver!=='function')return;
  if(drawer)new MutationObserver(queueMount).observe(drawer,{childList:true,subtree:true});
  if(page)new MutationObserver(queueMount).observe(page,{childList:true,subtree:true});
}

document.addEventListener('submit',function(event){
  var form=event.target&&event.target.closest?event.target.closest(attributionSelector):null;
  if(form)appendAttributionTags(form);
},true);

document.addEventListener('submit',function(event){
  var form=event.target&&event.target.closest?event.target.closest(captureSelector):null;
  if(!form||form.dataset.orCaptureNative==='true')return;
  if(form.dataset.orCaptureSubmitting==='true'){event.preventDefault();return}
  if(typeof form.checkValidity==='function'&&!form.checkValidity())return;

  event.preventDefault();
  track('signup_submit',sourceFor(form));
  setSubmitting(form,true);
  showStatus(form,'working','');

  var data=new FormData(form);
  fetch(form.action,{method:'POST',body:data,credentials:'same-origin',headers:{'Accept':'text/html','X-Requested-With':'XMLHttpRequest'}})
    .then(function(response){
      if(response.url&&response.url.indexOf('/challenge')!==-1){nativeFallback(form);return null}
      if(!response.ok)throw new Error('Customer capture request failed');
      return response.text().then(function(html){
        var result=new DOMParser().parseFromString(html,'text/html');
        if(result.querySelector('[data-or-server-success]'))return true;
        var error=result.querySelector('form.or-customer-capture [role="status"] .errors');
        if(error)throw new Error(error.textContent.trim());
        nativeFallback(form);return null;
      });
    })
    .then(function(result){if(result===null)return;handleSuccess(form);setSubmitting(form,false)})
    .catch(function(){setSubmitting(form,false);track('signup_error',sourceFor(form));showStatus(form,'error',errorTextFor(form))});
});

document.addEventListener('click',function(event){
  var button=event.target&&event.target.closest?event.target.closest('[data-or-capture-proxy-submit]'):null;
  if(!button)return;
  var proxy=button.closest(proxySelector);
  if(!proxy)return;
  event.preventDefault();
  submitProxy(proxy);
});
document.addEventListener('keydown',function(event){
  if(event.key!=='Enter')return;
  var email=event.target&&event.target.closest?event.target.closest('[data-or-capture-proxy-email]'):null;
  if(!email)return;
  var proxy=email.closest(proxySelector);
  if(!proxy)return;
  event.preventDefault();
  submitProxy(proxy);
});

document.addEventListener('or:customer-captured',function(event){
  var source=event.detail&&event.detail.source?event.detail.source:'';
  Array.prototype.forEach.call(document.querySelectorAll('.or-cart-capture'),function(panel){
    if(source&&panel.classList.contains('or-cart-capture--'+source.replace('cart-','')))return;
    panel.hidden=true;
  });
});

document.addEventListener('visitorConsentCollected',function(event){
  var detail=event&&event.detail?event.detail:{};
  var analyticsConsent=typeof detail.analyticsAllowed==='boolean'?detail.analyticsAllowed:analyticsAllowed();
  var preferencesConsent=typeof detail.preferencesAllowed==='boolean'?detail.preferencesAllowed:preferencesAllowed();
  var marketingConsent=typeof detail.marketingAllowed==='boolean'?detail.marketingAllowed:marketingAllowed();
  if(!analyticsConsent||!preferencesConsent||!marketingConsent){clearAttribution();return}
  ensureFirstTouch();
});

function track(name,source){
  if(!analyticsAllowed())return;
  var config=document.querySelector('[data-or-list-config]');
  var detail={surface:source,market:config?config.dataset.market:'',status:name==='signup_pending'?'pending_confirmation':undefined};
  try{if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function')Promise.resolve(window.Shopify.analytics.publish('renegade_'+name,detail)).catch(function(){})}catch(error){}
  window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:'renegade_'+name},detail));
}
window.ORListTrack=track;
if(typeof IntersectionObserver==='function'){
  var views=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting&&analyticsAllowed()){track('capture_view',sourceFor(entry.target));views.unobserve(entry.target)}})},{threshold:0.5});
  document.querySelectorAll(captureSelector+','+proxySelector).forEach(function(surface){views.observe(surface)});
}
document.addEventListener('click',function(event){if(event.target.closest('[data-or-account-link]'))track('account_click','footer')});
var config=document.querySelector('[data-or-list-config]');
if(config&&config.dataset.knownCustomer==='true')document.documentElement.dataset.orEmailCaptured='true';
if(preferencesAllowed())try{if(Number(localStorage.getItem('orListSignupUntil'))>Date.now())document.documentElement.dataset.orEmailCaptured='true'}catch(error){}
if(document.documentElement.dataset.orEmailCaptured==='true')document.querySelectorAll('[data-or-list-product]').forEach(function(panel){panel.hidden=true});
document.addEventListener('or:customer-captured',function(){
  if(preferencesAllowed())try{localStorage.setItem('orListSignupUntil',String(Date.now()+365*86400000))}catch(error){}
  document.querySelectorAll('[data-or-list-product]').forEach(function(panel){if(!panel.querySelector('[data-or-capture-status="success"]'))panel.hidden=true});
});
document.addEventListener('visitorConsentCollected',function(){if(!preferencesAllowed())try{localStorage.removeItem('orListSignupUntil')}catch(error){}});
document.querySelectorAll('form.or-customer-capture [data-or-server-success]').forEach(function(status){handleSuccess(status.closest('form'))});
ensureFirstTouch();
mountAll();
observeCartRegions();
document.addEventListener('shopify:section:load',function(){queueMount()});

})();
